function initialState() {
  return {
    user: {
      company: "",
      email: "",
      firstName: "",
      fullName: "",
      filters: {
        installationStatus: [],
        status: [],
        flags: []
      },
      groups: [],
      id: "",
      telephone: "",
      telephonePostponedTime: 0,
      lastName: "",
      token: "",

    },
  }
}

const mutations = {
  UPDATE_USER(state, user) {
    for (let key in user) {
      state.user[key] = user[key];
    }
  },
  REMEMBER_FILTER(state, filters) {
    for (let key in filters) {
      state.user.filters[key] = filters[key];
    }
  },

  RESET_USER(state) {
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}


export default {
  state: initialState,
  mutations
}